/* ARQUIVO CRIADO PARA ARMAZENAR FILTROS CUSTOMIZAVEIS */

import Vue from 'vue';
import dayjs from 'dayjs';

/****
 * Formatação de texto
 */

Vue.filter('toUpperCase', (str) => {
  return str.toUpperCase();
});

Vue.filter('toLowerCase', (str) => {
  return str.toLowerCase();
});

Vue.filter('replaceUnderscoresWithSpace', (str) => {
  return str.replace(/[_]/g, ' ');
});

/****
 * Formatação de números
 */

Vue.filter('parseNumberToIntegerBR', (num) => {
  return parseInt(num).toLocaleString('pt-BR');
});

Vue.filter('parseNumberToDecimalBR', (num, minimumFractionDigits = 2, maximumFractionDigits = 2) => {
  return Number(num).toLocaleString('pt-BR', {
    minimumFractionDigits: minimumFractionDigits,
    maximumFractionDigits: maximumFractionDigits
  });
});

Vue.filter('parseNumberToFloatBR', (num) => {
  return parseFloat(num).toLocaleString('pt-BR');
});

Vue.filter('bytesToSize', (bytes) => {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes == 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
});

/****
 * Formatação de datas
 */

Vue.filter('timeStampToDate', (timeStamp) => {
  return dayjs.unix(timeStamp).format('DD/MM/YYYY HH:mm');
});

Vue.filter('parseToDateTimeBR', (str) => {
  if (!str) str = '-';

  return str && str.length >= 10 ? dayjs(str).format('DD/MM/YYYY HH:mm') : str;
});

Vue.filter('formatToMonth', (data) => {
  if (!data) return '-';
  const [year, month] = data.split('-');
  return `${month}/${year}`;
});

Vue.filter('formatToMonth2', (data) => {
  if (!data) return '...';
  const [year, month] = data.split('-');
  return `${month}/${year}`;
});

Vue.filter('replaceFullDate', (str) => {
  return str && str.length >= 10 ? dayjs(str).format('DD/MM/YYYY HH:mm') : str;
});
